import { Container, Col, Modal, Form } from "react-bootstrap";

import "./recommendationView.css";

export default function RecommendationView({
  recommendationDetail,
  hideRecommendationPopup,
}: any) {
  if (recommendationDetail.showRecommendationPopup) {
    return (
      <Modal
        show={recommendationDetail.showRecommendationPopup}
        onHide={hideRecommendationPopup}
        backdrop="static"
        size="sm"
        dialogClassName="modal-200w"
        keyboard={false}
        enforceFocus={true}
        scrollable={true}
        backdropClassName="backdrop2"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title
            style={{
              color: "#495057",
              fontSize: "15px",
              fontWeight: 600,
            }}
          >
            View Recommendation
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container fluid={true}>
            <Col md="12" sm="12" xs="12" className="mt-2">
              <Form.Group className="mb-3" controlId="formBasicCheckbox">
                <Form.Control
                  as="textarea"
                  rows={10}
                  value={recommendationDetail.recommendationText}
                  name="recommendationText"
                  readOnly
                />
              </Form.Group>
            </Col>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <button className="buttonCss" onClick={hideRecommendationPopup}>
            Close
          </button>
        </Modal.Footer>
      </Modal>
    );
  } else {
    return <></>;
  }
}
